import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Layout, Loading, UserNavbar } from '../../../../../components';
import VenueSearchBar from './VenueSearchBar';
import { getRegisteredVenueOwners } from '../../../../../core/users/action';
import CardEvent from '../../../dashboard/components/CardEvent/CardEvent';
import UserCard from './UserCard';

const inputStyles = {
  backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

function RegisteredVenues() {
  const dispatch = useDispatch();
  const { usersList, loading } = useSelector((store) => store.users);

  useEffect(() => {
    dispatch(getRegisteredVenueOwners({}));
  }, [dispatch]);

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      <Grid mt={15} container justifyContent="center">
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <h1>Venues Registered</h1>
        </Grid>
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <VenueSearchBar />
        </Grid>
        <Grid item xs={9}>
          <Grid container>
            {usersList?.length > 0 ? (
              usersList.map((user) => (
                <Grid item xs={3} key={user.id} mt={2}>
                  <UserCard user={user} />
                </Grid>
              ))
            ) : (
              <Typography fontWeight="bold">No venues were found</Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default RegisteredVenues;
